export const sortObjectByKey = (obj: Record<string, any>): Record<string, any> => {
  return Object.keys(obj).sort().reduce(
    (o: any, key: string) => {
      o[key] = obj[key]?.toString();
      return o;
    },
    {}
  );
}